import React from 'react'
import BackgroundImage from '../../assets/imgs/home-background-image-1.png'

const FeaturedText = () => {
  return (
    <div
      className="featured-text"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${BackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container py-5">
        <div>
          <div className="text-left">
            <p className="featured-text-desc lh-sm">
              Waiting At <br /> Saloon For <br /> Hours?
            </p>
          </div>
          <div className="text-center">
            <p className="featured-text-desc lh-sm">
              Going Out <br /> On A Rainy <br /> Day?
            </p>
          </div>
          <div className="text-right">
            <p className="featured-text-desc lh-sm d-inline-block text-left">
              No One <br /> Wants To <br /> Do That!
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturedText
